<script>
import {onBeforeUnmount, onMounted, ref, watchEffect} from "vue";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import $ from "jquery";
import router from "@/router";

export default {
  name: "AuctionInformation",
  components: {LoadingPage},
  setup() {

    let loading = ref(false)
    let dialog = ref(false)

    let data_bid = ref(null)
    let offer_bid = ref({
      action: 'offer',
      bid: useRoute().params.bid,
      price: 0
    })

    let privacy = ref(false)
    let check_price_last = 0

    let time = ref('00:00:00')
    let hours = ref([])
    let minutes = ref([])
    let seconds = ref([])

    function load_bids(load) {

      if (load) loading.value = true

      FreeWorld.Heisenberg({type:'my'}, 'bids', true).then((res) => {

        loading.value = false

        let check
        res.data.bids.forEach((item) => {
          if (item.id == offer_bid.value.bid) {
            data_bid.value = item
            time.value = item.timer
            if (check_price_last !== item.price_last) {
              offer_bid.value.price = item.price_last
              offer_bid.value.price += data_bid.value.price_step
              check_price_last = item.price_last
            }
            check = true
            return false
          }
        })
        if (!check) router.push({name:'AuctionsPage'})


      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_bids)
      })


    }
    load_bids(true)

    function decreaseTimer() {
      let [hour, minute, second] = time.value.split(':').map(Number);

      second--;

      if (second < 0) {
        second = 59;
        minute--;

        if (minute < 0) {
          minute = 59;
          hour--;

          if (hour < 0) {
            hour = 0;
            minute = 0;
            second = 0;
            router.push({name:'AuctionsPage'})
            // Add actions if timer ends
          }
        }
      }

      time.value = `${hour}:${minute}:${second}`;
    }

    watchEffect(() => {
      let [hour, minute, second] = time.value.split(':').map(Number);

      hours.value = hour.toString().padStart(2, '0').split('');
      minutes.value = minute.toString().padStart(2, '0').split('');
      seconds.value = second.toString().padStart(2, '0').split('');
    });

    function add_offer(type) {

      switch (type) {
        case 'show' :
          if (!dialog.value) {
            $("#dialog").removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value = true
            if (offer_bid.value.price < data_bid.value.price_last + data_bid.value.price_step) {
              offer_bid.value.price += data_bid.value.price_step
            }
          } else {
            $("#dialog").removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              dialog.value = false
              offer_bid.value.price = check_price_last
            }, 700)
          }
          break;

        case 'dec' :
          if (offer_bid.value.price !== data_bid.value.price_last + data_bid.value.price_step) {
            offer_bid.value.price -= data_bid.value.price_step
          }
          break;

        case 'inc' :
          offer_bid.value.price += data_bid.value.price_step
          break;

        case 'send' :
          if (!privacy.value) {
            Swals.Fault('پذیرفتن شرایط و قوانین مزایده الزامی است!');
            return false
          }
          if (offer_bid.value.price === check_price_last) {
            Swals.Fault('لطفا مبلغ پیشنهادی خود را افزایش دهید!');
            return false
          }

          loading.value = true
          FreeWorld.Heisenberg(offer_bid.value, 'bids_act', true).then((res) => {

            loading.value = false
            if (res.data.status === 'ok') {
              load_bids(false)
              add_offer('show')
            } else {
              Swals.Fault('متاسفانه مبلغ پیشنهادی شما ثبت نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              add_offer('send')
            })
          })
          break;
      }

    }


    let update_timer = null
    let update_bids = null
    onMounted(() => {
      update_timer = setInterval(decreaseTimer, 1000);
      update_bids = setInterval(() => {
        load_bids(false)
      }, 10000);
    })
    onBeforeUnmount(() => {
      clearInterval(update_timer)
      clearInterval(update_bids)
    })

    return {

      time,
      hours,
      minutes,
      seconds,
      loading,
      offer_bid,
      data_bid,
      dialog,
      add_offer,
      privacy,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="add_offer('show')" class="bg_dialog"></div>

  <div id="main" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p dir="rtl" v-if="data_bid !== null" class="animate__animated animate__fadeIn font-color font-4 font-bold">{{ data_bid.name }}</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="data_bid !== null" class="p-body mt-3 animate__animated animate__fadeIn">

      <div class="bg-white shadow-custom rounded-4 p-3 d-flex align-items-center justify-content-between">
        <p class="font-4">تا پایان مزایده</p>

        <div class="d-flex align-items-center w-70">
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              seconds[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              seconds[0]
            }}</span>
          <span class="font-bold d-flex justify-content-center align-items-center mx-1">:</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              minutes[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              minutes[0]
            }}</span>
          <span class="font-bold d-flex justify-content-center align-items-center mx-1">:</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center">{{
              hours[1]
            }}</span>
          <span
              class="item_time font-3 font-color font-bold bg-color-light rounded-3 d-flex justify-content-center align-items-center mr-1">{{
              hours[0]
            }}</span>
        </div>
      </div>


      <div class="bg-white rounded-4 shadow-custom p-3 my-4">
        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/user-_2_.svg" alt="">

          <p class="font-4 mx-2">نفرات شرکت کننده :</p>

          <p class="font-4 d-flex align-items-center font-color font-bold">
            <span class="ml-1">{{ data_bid.entries }}</span>
            <span class="font-5">نفر</span>
          </p>
        </div>

        <div class="div_hr my-3"></div>

        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/increase.svg" alt="">

          <p class="font-4 mx-2">مبلغ هر گام :</p>

          <p class="font-4 d-flex align-items-center font-bold font-color">
            <span class="ml-1">{{ data_bid.price_step.toLocaleString() }}</span>
            <span class="font-5">تومان</span>
          </p>
        </div>

        <div class="div_hr my-3"></div>

        <div class="d-flex align-items-center">
          <img style="height: 20px" src="../assets/img/hammer.svg" alt="">

          <p class="font-4 mx-2">آخرین پیشنهاد :</p>

          <p class="font-4 d-flex align-items-center font-color font-bold">
            <span class="ml-1">{{ data_bid.price_last.toLocaleString() }}</span>
            <span class="font-5">تومان</span>
          </p>
        </div>


      </div>

      <div class="bg-color rounded-3 p-3 shadow-custom d-flex align-items-center mb-3">
        <img style="height: 25px" src="../assets/img/bid-_2_.svg" alt="">

        <p class="font-4 font-bold text-white mr-3">پیشنهادات مزایده</p>
      </div>

      <div class="overflow-hidden">
        <div class="list">

          <div v-for="item in data_bid.offers" :key="item.id"
               class="offer animate__animated animate__fadeInDown p-3 rounded-3 d-flex align-items-center justify-content-between mb-2 shadow-custom">
            <div class="w-30">
              <p class="font-4 font-color">{{ item.name }}</p>
            </div>

            <p class="font-4 d-flex align-items-center font-color">
              <span class="">{{ item.price.toLocaleString() }}</span>
              <span class="font-5 mr-1">تومان</span>
            </p>

            <p class="font-5 font-color">{{ item.time }}</p>
          </div>

        </div>
      </div>

    </div>

    <br>
    <br>
    <br>
    <br>

    <div v-if="data_bid !== null" class="animate__animated animate__fadeIn bg-main d-flex justify-content-center position-fixed bottom-0 w-100 max_width">
      <v-btn @click="add_offer('show')"
             class="bg-color h-100 text-white font-4 font-bold shadow-custom mb-3 w-70 p-3 rounded-4">ثبت پیشنهاد جدید
      </v-btn>
    </div>


    <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_dialog_mozayedeh.svg" alt="">
          <p class="text-white font-4">ثبت پیشنهاد</p>
        </div>

        <div class="p-3">

          <p class="font-bold font-4 font-color mb-2">پیشنهاد شما</p>
          <div
              class="p-3 bg-color-light shadow-custom d-flex justify-content-between align-items-center rounded-4 w-100 mb-3">
            <img @click="add_offer('inc')" style="height: 4vh" class="icon_shadow" src="../assets/img/plus_icon.svg"
                 alt="">

            <p class="font-4">{{ offer_bid.price.toLocaleString() }}</p>

            <img @click="add_offer('dec')" style="height: 4vh" class="icon_shadow" src="../assets/img/min_icon.svg"
                 alt="">
          </div>

          <div class="d-flex align-items-center mb-4">
            <input v-model="privacy" id="privacy" type="checkbox">
            <label class="font-4 mr-2" for="privacy">با قوانین مزایده موافقم</label>
          </div>


          <div class="d-flex justify-content-center align-items-center">
            <v-btn @click="add_offer('send')"
                   class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ثبت پیشنهاد
            </v-btn>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>


<style scoped>

.item_time {
  width: 8vw;
  height: 4vh;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.list > .offer:nth-child(odd) {
  background-color: #9FDBF7;
}

.list {
  max-height: 40vh;
  overflow-y: scroll;
}


</style>